import React from 'react';
import { useEffect, useState, useRef } from 'react';

import { Formik } from 'formik';
import * as yup from 'yup';
import Select from 'react-select';

import { Form, Stack, Row, Col, Button, Badge } from 'react-bootstrap';

import Alert from '../helper/Alert';
import useRequest from '../helper/useRequest';
import { toast } from 'react-toastify';
import Loader from '../helper/Loader';

import Editor from '../helper/Editor';

import { subject } from '../helper/Schema';

import MandatoryFieldNotice from '../helper/MandatoryFieldNotice';

const schema = yup.object().shape({
    subject: subject,
});

function UserMail() {
    const { request } = useRequest();

    const [users, setUsers] = useState(false);
    const [message, setMessage] = useState("");
    const [attachments, setAttachments] = useState([]);
    const [loading, setLoading] = useState(false);
    const formRef = useRef(null);
    const editorRef = useRef(null);

    const sendMail = async (values) => {
        if (values.reciever.length == 0) return toast.error("Sie müssen mindestens einen Empfänger auswählen.");

        setLoading(true);
        var data = { ...values };
        data.reciever = data.reciever.map(item => item.value);
        const result = await request("/Operator/UserMail", data);
        const json = result.data;

        setLoading(false);
        if (json.r == 1) {
            toast.success("Nachricht wurde erfolgreich versandt.");
            formRef.current.setFieldValue("reciever", []);
            formRef.current.setFieldValue("subject", "");
            formRef.current.setFieldValue("message", "");
            setAttachments([]);
            editorRef.current.setContent('');
        }
        else {
            setMessage(json.message);
        }
    }

    const sendPreview = async (values) => {
        setLoading(true);
        var data = { ...values };
        data.attachments = attachments;
        data.message = editorRef.current.getContent();
        data.reciever = data.reciever.map(item => item.value);
        const result = await request("/Operator/UserMailPreview", data);
        const json = result.data;

        setLoading(false);
        if (json.r == 1) {
            toast.success("Nachricht wurde erfolgreich versandt.");
        }
        else {
            setMessage(json.message);
        }
    }

    const addFile = () => {
        var fileNode = document.createElement("input");
        fileNode.type = "file";
        fileNode.multiple = true;
        fileNode.addEventListener("change", function (e) {
            setAttachments(oldAttachments => [...oldAttachments, ...e.currentTarget.files]);
        });
        fileNode.click();
    }

    const removeFile = (index) => {
        setAttachments(oldAttachments => oldAttachments.filter((value, index2) => index != index2));
    }

    useEffect(() => {
        const getUsers = async () => {
            const result = await request("/Operator/GetUsers");
            const json = result.data;
            if (json.r == 1) {
                setUsers(json.users.map(item => { return {value: item.UserID, label: item.FirstName + " " + item.LastName} }));
            }
            else {
                setMessage(json.message);
            }
        };

        getUsers();
    }, []);

    if(users === false) return <Loader />

    return (
        <Formik
            innerRef={(f) => (formRef.current = f)}
            validationSchema={schema}
            onSubmit={(values) => {
                values.attachments = attachments;
                values.message = editorRef.current.getContent();
                sendMail(values);
            }}
            initialValues={{
                reciever: [],
                subject: '',
                message: '',
            }}
        >
            {({
                handleSubmit,
                handleChange,
                handleBlur,
                values,
                touched,
                isValid,
                errors,
            }) => {

                return (
                    <Form noValidate onSubmit={handleSubmit}>
                        <Stack gap={2}>
                            {message && <Alert type="error" message={message} />}
                            <Form.Group as={Row} className="mb-3" controlId="reciever">
                                <Form.Label className="required" column sm={2}>Empfänger</Form.Label>
                                <Col sm={10}>
                                    <Select styles={{menu: base => ({...base, zIndex: "3"})}} closeMenuOnSelect={false} isMulti isInvalid={errors.reciever && touched.reciever} name="reciever" value={values.reciever} options={users} classname="basic-multi-select" placeholder="Bitte auswählen" onChange={
                                        (values) => {
                                            return formRef.current.setFieldValue("reciever", values);
                                        }
                                    } />
                                    <Form.Control.Feedback type="invalid">
                                        {errors.reciever}
                                    </Form.Control.Feedback>
                                </Col>
                            </Form.Group>
                            <Form.Group as={Row} className="mb-3" controlId="subject">
                                <Form.Label className="required" column sm={2}>Betreff</Form.Label>
                                <Col sm={10}>
                                    <Form.Control isInvalid={errors.subject && touched.subject} type="text" name="subject" value={values.subject} onBlur={handleBlur} onChange={handleChange} />
                                    <Form.Control.Feedback type="invalid">
                                        {errors.subject}
                                    </Form.Control.Feedback>
                                </Col>
                            </Form.Group>
                            <Form.Group as={Row} className="mb-3" controlId="attachment">
                                <Form.Label column sm={2}>Anhang</Form.Label>
                                <Col sm="auto">
                                    <Button disabled={loading} size="sm" variant="primary" type="button" onClick={addFile}><i className="fa-solid fa-upload"></i> Anhang hinzufügen</Button>
                                </Col>
                                <Col sm={6}>
                                    <Stack direction="horizontal" gap={2}>
                                        {attachments.map((file, index) => {
                                            return (
                                                <Badge key={index} bg="secondary">
                                                    {file.name}
                                                    <Button size="sm" variant="link" onClick={() => removeFile(index) }><i className="fa-solid fa-trash ms-2"></i></Button>
                                                </Badge>
                                            );
                                        })}
                                    </Stack>
                                </Col>
                            </Form.Group>
                            <Form.Group as={Row} className="mb-3" controlId="message">
                                <Form.Label column sm={2}>Nachricht</Form.Label>
                                <Col sm={10}>
                                    <Editor
                                        onInit={(evt, editor) => editorRef.current = editor}
                                        initialValue=''
                                        init={{
                                            height: 500,
                                            menubar: false,
                                            branding: false,
                                            plugins: [
                                                'advlist', 'anchor', 'autolink', 'image', 'link', 'lists',
                                                'searchreplace', 'table'
                                            ],
                                            toolbar: 'undo redo | blocks | ' +
                                                'bold italic forecolor | alignleft aligncenter ' +
                                                'alignright alignjustify | bullist numlist outdent indent | ' +
                                                'removeformat image'
                                        }}
                                    />
                                </Col>
                            </Form.Group>
                            <Row>
                                <Col sm={6}>
                                    <Button disabled={loading} variant="primary" type="button" onClick={() => sendPreview(values)}>
                                        <i className="fa-solid fa-search me-2"></i>Vorschau versenden
                                    </Button>
                                </Col>
                                <Col sm={6} className="text-end">
                                    <Button disabled={loading} variant="primary" type="submit">
                                        <i className="fa-solid fa-paper-plane me-2"></i>Nachricht versenden
                                    </Button>
                                </Col>
                            </Row>
                            
                        </Stack>

                        <MandatoryFieldNotice />
                    </Form>
                )
            }}
        </Formik>
    );
}

export default UserMail;